import * as React from 'react';
import { SpateAiIcon } from './spate-ai-icon';
import { cn } from '../../utils/cn';

const AnimatedSpateAiIcon = React.forwardRef(
    ({ className, size = 16, speed = 900, ...props }, ref) => (
        <SpateAiIcon
            ref={ref}
            size={size}
            className={cn('animate-spin-ease', className)}
            style={{ '--spin-duration': `${speed}ms` }}
            {...props}
        />
    ),
);
AnimatedSpateAiIcon.displayName = 'AnimatedSpateAiIcon';

export { AnimatedSpateAiIcon };
